import React, {Component} from 'react';
import MainMenu from '../../components/menu/MainMenu';
import { Card, Col, Row, Container, CardDeck } from 'react-bootstrap';
import moment from 'moment';
import Announce01 from '../../resources/images/pgw.png';
import './Announce.css';
class Announce extends Component {

    constructor(props) {
        super();
    }    
    render() {
        const {role} = this.props;
        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu role={role}/>
                        <Container>
                            <Row className="mt-5">
                                <Col className="pl-0">
                                    <h1 className='font-weight-bold text-scb page-title'>ANNOUNCEMENT</h1>
                                </Col>
                            </Row>  
                            <Row className="mt-3">
                                <Col>
                                    <CardDeck>
                                        <Card className="shadow">
                                            <Card.Header className="bg-scb-gradient text-light">
                                                <h2 className="my-5 py-5">SCB PAYMENT GATEWAY</h2>
                                            </Card.Header>
                                            <Card.Body>
                                                <Card.Title className="font-weight-bold text-grey">
                                                    Welcome to SCB Payment Gateway
                                                </Card.Title>
                                                <Card.Text className="mt-4 text-justify text-dark">
                                                    <p>
                                                        SCB Payment Gateway serves e-commerce partners the ability to receive direct debit payment real-time from registered SCB accounts of retail customer as a payer to registered SCB accounts of e-commerce partners as a merchant.
                                                    </p>
                                                    <p>
                                                        SCB Payment Gateway also serves administrative features to support day-to-day operation for all e-commerce partners launched as
                                                        <span className="font-weight-bold font-italic"> SCB Payment Gateway Admin Portal. </span> 
                                                        For the administrative portal service, there are two web-based application versions of SCB Payment Gateway Admin Portal which are intranet version for SCB users and public version for merchant users separately. The public admin portal allows merchant users to manage a subset of administrative functions according to set up in user management where related to their own company only.
                                                    </p>
                                                </Card.Text>                                                
                                            </Card.Body>
                                            <Card.Footer>
                                                <small className="text-muted">Last updated {moment("20200814000001", "YYYYMMDDHHmmss").fromNow()}</small>
                                            </Card.Footer>
                                        </Card>
                                    </CardDeck>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>     
            </React.Fragment>
        );
      }
}
export default Announce;